module.exports = __webpack_public_path__ + "img/logo.377475c0.png";